<div class="page-header-menu">
  <div class="company-logo header-left-panel">
    <img style="max-width: 119px;" src="/assets/images/temp/mobisoft-final-logo.png">
  </div>
  <div class="header-right-panel grid justify-content-end  align-items-center vertical-containe">
    <div class="col-fixed pb-0">
      <div class="top-bar-item">
        <a (click)="onSideMenuClick($event)" class="hamburger-menu">
          <i class="fa fa-bars"></i>
        </a>
      </div>
    </div>
    <div class="col pb-0">
      <div class="nav-right-menu grid justify-content-end  align-items-center vertical-containe">
        <div class="col-fixed pb-0">
          <div class=" top-bar-item notifications-bell" (click)="getNotificationListAndToggle($event)">
            <a class="nav-notifications-icon">
              <i class="fa fa-bell-o" aria-hidden="true"></i>
              <div class="new-notification-count" *ngIf="unReadNotificatonsCount">
                {{unReadNotificatonsCount}}
              </div>
            </a>
          </div>
        </div>

        <div class="col-fixed pb-0">
          <p-menu #menu popup="popup" [model]="items"></p-menu>
          <div class="profile-menu-button">
            <a (click)="menu.toggle($event)">
              <img class="user-photo" src="{{profileUrl}}" onerror="src='/assets/images/temp/default_profile.png'">
              <div style="display: inline-block;">{{userFullName}} <i class="fa fa-angle-down" aria-hidden="true"></i>
                &nbsp;</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-drawer [(visible)]="hasShowNotificationBar" [showCloseIcon]="false" position="right">
  <!-- <div class="notification-container p-4"> -->
  <!-- <div class="grid">
      <div class="col">
      <div class="header">
        {{notificationLabel}}
      </div>
      </div> 
      <div class="col-fixed">
        <li class="pi pi-times pointer" (click)="hasShowNotificationBar = false"></li>
      </div>
    </div> -->
  <ng-template pTemplate="header">
    <div class="border-bottom-1 flex w-full align-items-center justify-content-between px-3 text-base cursor-pointer">
      <div class="flex align-items-center gap-3">
        <h3 translate>{{notificationLabel}} </h3>
      </div>
      <li class="pi pi-times pointer" (click)="hasShowNotificationBar = false"></li>
    </div>
  </ng-template>
  <div class="content mb-2">
    <app-notification-mg1 [notifications]="notifications" (loadMoreNotification)="loadMoreNotification()">
    </app-notification-mg1>
  </div>
  <!-- </div> -->
</p-drawer>

<p-dialog modal="true" styleClass="add-terms-popup" [style]="{'width': '600px'}" [(visible)]="changePasswordPopup"
  header="Change Password">
  <app-change-password [(changePasswordPopup)]="changePasswordPopup"
    (isShowChangePassword)="onCancelChangePassword($event)"></app-change-password>
</p-dialog>

<p-dialog modal="true" styleClass="edit-profile-popup" position="center center" responsive="true"
  [(visible)]="editProfilePopup" [style]="{'width': '750px'}" header="Edit Profile">
  <app-edit-profile [(editProfilePopup)]="editProfilePopup" (showProfilePopup)="onCancelEditProfile($event)">
  </app-edit-profile>
</p-dialog>
<!-- <p-messages [(value)]="message" [closable]="false"></p-messages> -->
<!-- <p-toast key="commonToast"></p-toast> -->